export const bar1 = {
    initial:{
        y: 0,
        rotate: '0deg',
        background: 'var(--color-LB)',
        transition: {
            duration: .25,
            type: 'tween',
            ease: 'linear'
        }
    },
    animate:{
        y: "8px",
        rotate: '45deg',
        background: 'var(--color-GB)',
        transition: {
            duration: .25,
            type: 'tween',
            ease: 'linear'
        }
    }
}

export const bar2 = {
    initial:{
        y: 0,
        rotate: '0deg',
        background: 'var(--color-LB)',
        transition: {
            duration: .25,
            type: 'tween',
            ease: 'linear'
        }
    },
    animate:{
        y: "-8px",
        rotate: '-45deg',
        background: 'var(--color-GB)',
        transition: {
            duration: .25,
            type: 'tween',
            ease: 'linear'
        }
    }
}

export const navBG = {
    initial:{
        clipPath: "circle(0px at 100% -10%)",
        transition:{
            duration: .5,
            ease: 'linear'
        }
    },
    animate:{
        clipPath: "circle(1500px at 100% -10%)",
        transition:{
            duration: .5,
            ease: 'linear'
        }
    }
}

export const navLi = {
    initial:{
        x: "100%",
        opacity: 0,
        transition: {
            duration: .25
        }
    },
    animate:{
        x: 0,
        opacity: 1,
        transition: {
            duration: .5,
            ease: 'easeOut'
        }
    }
}